import { findRows } from './oppu_hierarchy';

export const EXPANSION_STATUS = Object.freeze({
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
});

export const toggleStatus = (item) => {
  const { status } = item;
  item.status = status === EXPANSION_STATUS.COLLAPSE ? EXPANSION_STATUS.EXPAND : EXPANSION_STATUS.COLLAPSE;
};

export const toggleLoading = (item) => {  
  item.loading = !item.loading;  
};

export const setChildrenVisibility = (children, isVisible, reportRows) => {
  for (let child of children || []) {
    let childRows = findChildRows(child, reportRows);
    if (childRows) {
      childRows.forEach((r) => {
        r.visible = isVisible;

        // If the child item was collapsed, children should already be hidden.
        // In that case, we don't want to reset the visibility of the children.
        // We reset the visibility only when the item is expanded.
        if (r.status !== EXPANSION_STATUS.EXPAND) {
          setChildrenVisibility(r.children, isVisible, reportRows);
        }
      });
    }
  }
};

export const allChildrenLoaded = (children, reportRows) => {
  return children.every((c) => {
    let childRows = findChildRows(c, reportRows);
    return childRows && childRows.length && childRows[0].loaded;
  });
};

const findChildRows = (child, reportRows) => {
  const parts = child.split('/');
  const childChannel = parts[0];
  const childComponent = parts[1];
  return findRows(reportRows, childComponent, childChannel);
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/toggle.js